"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./Problemsection.css";

const icons = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>,
];

export default function ProblemSection() {
  const { t } = useTranslation("landingPage");

  useRevealOnScroll();

  const problemsRaw = t("problem.cards", { returnObjects: true });
  const problems = Array.isArray(problemsRaw) ? problemsRaw : [];

  if (!problems.length) {
    return null;
  }

  return (
    <section className="problem">
      <div className="container">
        <div className="problem__header reveal-on-scroll reveal-up">
          <p className="problem__label">{t("problem.label")}</p>

          <h2 className="problem__title">
            {t("problem.title.part1")}
            <span className="problem__title-accent">
              {" "}
              {t("problem.title.accent")}{" "}
            </span>
            <br />
            {t("problem.title.part2")}
          </h2>

          <p className="problem__subtitle">{t("problem.subtitle")}</p>
        </div>

        <div className="problem__grid">
          {problems.map((p, i) => (
            <div
              key={i}
              className="problem__card reveal-on-scroll reveal-card"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="problem__card-icon">{icons[i]}</div>
              <h3 className="problem__card-title">{p.title}</h3>
              <p className="problem__card-desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}